import { useState } from "react";
import { Play, Film } from "lucide-react";

const providerLabel = { youtube: "YouTube", vimeo: "Vimeo", drive: "Google Drive" };

export const VideoEmbed = ({ video, testId = "video-embed" }) => {
  const [playing, setPlaying] = useState(false);
  const [thumbOk, setThumbOk] = useState(true);
  if (!video?.embed_url) return null;
  if (playing) {
    const sep = video.embed_url.includes("?") ? "&" : "?";
    const src = video.provider === "drive" ? video.embed_url : `${video.embed_url}${sep}autoplay=1`;
    return (
      <div className="relative w-full rounded-xl overflow-hidden mb-3 bg-black" style={{ aspectRatio: "16/9" }} data-testid={`${testId}-player`}>
        <iframe src={src} title="Vlog" className="absolute inset-0 w-full h-full border-0"
          allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen />
      </div>
    );
  }
  return (
    <button type="button" onClick={() => setPlaying(true)} data-testid={testId}
      className="relative w-full rounded-xl overflow-hidden mb-3 bg-gradient-to-br from-[#1B263B] to-black group block text-left">
      <span className="block w-full" style={{ aspectRatio: "16/9" }} />
      {video.thumb_url && thumbOk && (
        <img src={video.thumb_url} alt="Vlog voorbeeld" loading="lazy" decoding="async"
          onError={() => setThumbOk(false)}
          className="absolute inset-0 w-full h-full object-cover opacity-85 group-hover:opacity-100 transition-[opacity] duration-200" />
      )}
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="w-14 h-14 rounded-full bg-white/90 group-hover:bg-white flex items-center justify-center shadow-lg group-hover:scale-105 transition-[transform,background-color] duration-200">
          <Play className="w-6 h-6 text-black ml-0.5" fill="currentColor" />
        </span>
      </span>
      <span className="absolute bottom-2 right-2.5 flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide text-white/95 bg-black/55 rounded-full px-2.5 py-1">
        <Film className="w-3 h-3" /> {providerLabel[video.provider] || "Video"}
      </span>
    </button>
  );
};
